import type { ThemeNames } from '@sravni/design-system-theme';
import Head from 'next/head';

import { IFRAME_RESIZER_SCRIPT_CDN } from 'constants/links';

import { useAppSelector } from 'shared/lib/redux';

import { isWLSelector } from 'entities/whiteLabels';

import { WLTheme } from '../WLTheme/WLTheme';

interface IWLContentProps {
  dataThemeName: ThemeNames;
  children: Nullable<JSX.Element>;
}

export const SiteFlowWrapper: FC<IWLContentProps> = ({ children, dataThemeName }) => {
  const isWl = useAppSelector(isWLSelector);

  if (isWl) {
    return (
      <>
        <Head>
          <script src={IFRAME_RESIZER_SCRIPT_CDN} />
        </Head>
        {children}

        <WLTheme dataThemeName={dataThemeName} />
      </>
    );
  }

  return children;
};
